import ApiResponse from "../resources/domain/entity/IApiResponse";
import * as http from "../util/http";
import endpoint from "../constants/endpoint";
import { ICommonDataForApi } from "../Interfaces/CommonInterface";


export const currentAdmin = (): Promise<ApiResponse> => {
    return http.get(`${endpoint.admin.CURRENT}`);
};

export const getAdminUserDetails = (data?: any): Promise<ApiResponse> => {
    const queryParams: string[] = [];
    if (data && Object.keys(data).length) {
        Object.keys(data).map((key: any) => {
            queryParams.push(`${key}=${data[key]}`);
        });
    }
    return http.post(`${endpoint.admin.ADMIN_USER_DETAIL}`, data );
 
};

export const getUserList = (data?: any): Promise<ApiResponse> => {
    const queryParams: string[] = [];


    if (data && Object.keys(data).length) {
        Object.keys(data).map((key: any) => {
            queryParams.push(`${key}=${data[key]}`);

        });
    }

    return http.get(
        `${endpoint.admin.USER_LIST}${queryParams && queryParams.length > 0 ? `?${queryParams.join("&")}` : " "}`,
    );
};

export const forgetAdminPassword = (data: string): Promise<ApiResponse> => {
    return http.post(`${endpoint.admin.FORGET_PASSWORD}`, { email: data });
};

export const resetAdminPassword = (data: any): Promise<ApiResponse> => {
    return http.post(`${endpoint.admin.RESET_PASSWORD}`, data);
};

export const verifyAdminResetLink = (token: string): Promise<ApiResponse> => {
    return http.post(`${endpoint.admin.VERIFY_RESET_LINK}`, { token });
};

// Plain-admin-tier customer account edit - was superuser-only with no
// regular-admin equivalent at all (see routes.ts's own comment on the new
// admin.post('/editUserDetail') route this calls).
export const editUserDetail = (data: any): Promise<ApiResponse> => {
    return http.post(`${endpoint.admin.EDIT_USER_DETAIL}`, data);
};

// Support-scenario email change - see UserService.adminChangeUserEmail's
// own comment for why this is separate from editUserDetail above (that
// one has no uniqueness check, no Stripe sync, no userCache refresh -
// none of which are optional for email specifically).
export const adminChangeUserEmail = (data: {
    userId: string;
    newEmail: string;
}): Promise<ApiResponse> => {
    return http.post(`${endpoint.admin.ADMIN_CHANGE_USER_EMAIL}`, data);
};

export const getAuditLog = (data?: any): Promise<ApiResponse> => {
    const queryParams: string[] = [];
    if (data && Object.keys(data).length) {
        Object.keys(data).map((key: any) => {
            queryParams.push(`${key}=${data[key]}`);
        });
    }
    return http.get(
        `${endpoint.admin.AUDIT_LOG}${queryParams && queryParams.length > 0 ? `?${queryParams.join("&")}` : ""}`,
    );
};

export const getCancellationFeedback = (data?: any): Promise<ApiResponse> => {
    const queryParams: string[] = [];
    if (data && Object.keys(data).length) {
        Object.keys(data).map((key: any) => {
            queryParams.push(`${key}=${data[key]}`);
        });
    }
    return http.get(
        `${endpoint.admin.CANCELLATION_FEEDBACK}${queryParams && queryParams.length > 0 ? `?${queryParams.join("&")}` : ""}`,
    );
};

export const getOnboardingInsights = (): Promise<ApiResponse> => {
    return http.get(`${endpoint.admin.ONBOARDING_INSIGHTS}`);
};

export const addAccountNote = (data: { userId: string; note: string }): Promise<ApiResponse> => {
    return http.post(`${endpoint.admin.ADD_ACCOUNT_NOTE}`, data);
};

export const getAccountNotes = (userId: string): Promise<ApiResponse> => {
    return http.get(`${endpoint.admin.ACCOUNT_NOTES}?userId=${userId}`);
};

export const adminTwoFactorConfirmation = (data: { code: string; email: string }): Promise<ApiResponse> => {
    return http.post(`${endpoint.admin.TWO_FACTOR_CONFIRMATION}`, data);
};

export const resendAdminTwoFactorCode = (email: string): Promise<ApiResponse> => {
    return http.post(`${endpoint.admin.RESEND_TWO_FACTOR_CODE}`, { email });
};
